import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Galerij from "../components/galerij"

const IndexPage = ({data}) => (
  <Layout taal="en">
    <SEO title="Home" />
	<div className="tekstvak">
		<p>Hello,</p>
		<p>Call me 3wao, occasional artist.</p>
		<p>Enjoy my site. You can download any images for personal use. Send me an <a href="mailto:3wao@mail.com">e-mail</a> if you would like to use them for any other purpose.</p>
		<p>If you really think my work is pretty/interesting/true, you can support new work at <a href="https://opensea.io/3wao?tab=created">OpenSea</a>. If you don't like NFTs, a charity gift card like <a href="https://www.goodgift.be">Good gift</a> or <a href="https://www.charitygiftcertificates.org">www.charitygiftcertificates.org</a> would also make me happy.</p>
	</div>
	<div>
		<h3>Gallery</h3>
		<Galerij data={data} taal="en"/>
	</div>
  </Layout>
)

export default IndexPage

export const pageQuery = graphql`
 query {
  allMetadataYaml(sort: {order: ASC, fields: id}) {
    edges {
      node {
        id
        file
        en {
         titel
		}
      }
    }
  }
}

`
